import IMAGE from "Content/fileIcons/image.svg";
import FILE from "Content/fileIcons/file.svg";
import fileType from "./fileType";
export default {
    [fileType.EXCEL]: FILE,
    [fileType.FILE]: FILE,
    [fileType.IMAGE]: IMAGE,
    [fileType.PDF]: FILE,
    [fileType.TXT]: FILE,
    [fileType.VISIO]: FILE,
    [fileType.WORD]: FILE
};
